module.exports = __webpack_public_path__ + "static/media/error_image.e12240c4.png";